import React, { useEffect, useState } from "react";
import { ExpandableText } from "components/ExpandableText";
import { sponsors } from "../../assets/sponsored_content/sponsors.js";



const ProgrammeSection = () => {
  const programmeDay1 = [
    // {
    //   //img: require("../assets/img/pattern_react.png"),
    //   time: "14:45",
    //   heading: "Konferences sākums",
    //   description: "",
    // },
    // {
    //   //img: require("../assets/img/pattern_react.png"),
    //   time: "15:00 - 16:00",
    //   speaker: "Jevgēnija Kondratjeva",
    //   heading: "Kaķi - tie nav mazi suņi",
    //   language: "LV",
    //   topic: "Kaķu Dermatoloģija",
    //   description: "",

    // },
    // {
    //   //img: require("../assets/img/pattern_react.png"),
    //   time: "16:00 - 17:00",
    //   speaker: "Marge Chandler",
    //   heading: "Palīdzība kaķu adoptētājiem, izvēloties piemērotu kaķu barību ",
    //   altheading: "Helping Cat Caregivers Choose a Cat Food",
    //   language: "EN",
    //   topic: "Kaķu Uzturs",
    //   description: "Vai vajadzētu apsvērt alternatīvas diētas idejas kaķiem, piemēram, bezgraudu, neapstrādātu (raw), veģetāro, ar insektu olbaltumvielām? Kādas ir priekšrocības un riski? \nKaķu gremošanas trakta īpatnības un to ietekme uz uztura prasībām. \nDiētas izvēle kaķiem: iepakojuma formāts un marķējuma atšifrēšana.",
    // },
    // {
    //   time: "",
    //   speaker: "",
    //   description: "",
    //   type: "sponsorship-spotlight",
    //   sponsor: "Dimedium",
    //   class: "gold",
    // },
    // {
    //   //img: require("../assets/img/pattern_react.png"),
    //   time: "17:00 - 18:00",
    //   speaker: "Sarah Collins",
    //   language: "EN",
    //   heading: "Kaķiem draudzīgas klīnikas izveide: kā radīt vidi, kurā kaķi jūtas droši un mierīgi",
    //   altheading: "Creating a Cat Haven: How to Make Your Clinic Cat-Friendly",
    //   topic: "Cat Friendly Klīnikas",
    //   description: "In this presentation we will focus on the most frequently used areas in a clinic;  the waiting room, the examination room and the hospitalisation area, and present key points on how to make these spaces more comfortable and less stressful for cats. The presentation will provide practical, simple, and low-cost methods for creating a cat-friendly clinic such as setting aside a dedicated space for cats in the waiting room, considering sights and sounds in the examination room and how to set up a hospitalisation cage in a cat friendly manner. Small changes make a big difference, and we will share ideas which require minimal effort and cost that can be implemented right away to transform a clinic into a more cat-friendly environment.",
    // },

    // {
    //   //img: require("../assets/img/pattern_react.png"),
    //   time: "18:00 - 18:30",
    //   speaker: "",
    //   heading: "Kafijas pauze",
    //   description: "",
    // },
    // {
    //   //img: require("../assets/img/pattern_react.png"),
    //   time: "18:30 - 19:30",
    //   speaker: "Jevgēnija Ostroga",
    //   heading: "Stereotipijas kaķiem: diagnostika un ārstēšanas pieejas veterinārmedicīnā",
    //   language: "LV",
    //   topic: "Veterinārā uzvedības medicīna",
    //   description: "Kas ir stereotipijas un kā tās atšķirt no normālas uzvedības.\nStereotipiju rašanās iemesli mājas kaķiem.\nDiferenciāldiagnozes.\nĪpašnieka, vides un ikdienas rutīnas loma stereotipiju gadījumos.\nMūsdienīgas ārstēšanas pieejas: vides pielāgošana, uzvedības terapija, veterinārā aprūpe. \nBarības piedevu un medikamentozās terapijas pielietojums: indikācijas, ierobežojumi, reāli gadījumi no prakses.",
    // },
    // {
    //   //img: require("../assets/img/pattern_react.png"),
    //   time: "19:30 - 20:00",
    //   heading: "Noslēguma daļa: auditorijas jautājumi un pateicības",
    //   description: "",
    // }
  ];

  const programmeDay2 = [
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "9:45",
      heading: "Konferences sākums",
      description: "",
    },
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "10:00 - 11:00",
      speaker: "Daira Viškere",
      heading: "Traumu menedžments kaķiem: praktiska pieeja neatliekamās palīdzības sniegšanā",
      language: "LV",
      topic: "Kaķu neatliekamā palīdzība",
      description: "Kaķis nav suns... arī neatliekamās palīdzības kabinetā. Lekcijā stāstīšu par niansēm neatliekamās palīdzības sniegšanā kaķiem pie dažādām traumām. Runāsim par šoku un sāpēm, kā arī to, kā stabilizēt dzīvnieka stāvokli nonākot veterinārajā klīnikā.",

    },
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "11:00 - 12:00",
      speaker: "Sarah Heath",
      heading: "Kaķu emocionālā veselība un tās nozīme veterinārpraksē",
      altheading: "Considering feline emotional health and its relevance to the veterinary visit",
      language: "EN",
      topic: "Veterinārā uzvedības medicīna",
      description: "This presentation will discuss the range of emotions which cats experience and consider their relevance within the context of the veterinary visit. It will introduce the concept of emotional health and explore how considering this in relation to feline patients can optimise the veterinary experience for the patient and also be beneficial for caregivers and veterinary staff.",
    },
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "12:00 - 13:00",
      speaker: "Ksenija Polonska",
      language: "LV",
      heading: "Pet-friendly medikamenti, zāļu ievadīšanas metodes",
      topic: "Terapija",
      description: "",
    },
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "13:00 - 14:00",
      speaker: "",
      heading: "Pusdienu pārtraukums",
      description: "",
    },
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "14:00 - 15:00",
      speaker: "Irina Azina",
      heading: "Fikcija vai FIC? Kaķa urīnpūslis kā stresa spogulis",
      language: "LV/EN",
      topic: "Idiopātisks cistīts kaķiem",
      description: "Idiopātiskais kaķu cistīts (FIC - Feline Idiopathic Cystitis) — izplatīta, bet joprojām nepilnīgi izpētīta apakšējo urīnceļu saslimšana kaķiem. Tas ir izslēgšanas diagnoze, kuras risināšanā nepieciešama delikāta pieeja gan veterinārārsta, gan zoopsihologa pusē. Mūsdienīgs skatījums uz slimības etioloģiju, patoģenēzi un klīnisko ainu. Diagnostikas īpatnības un izaicinājumi praksē. Multidisciplināras pieejas izmantošana ārstēšanā: speciālistu sadarbība un aktīva īpašnieka iesaiste kā atslēga veiksmīgam iznākumam. Divi klīniskie gadījumi. Praktiski piemēri starpdisciplināras pieejas efektivitātei.",
    },
    {
      time: "",
      speaker: "",
      description: "",
      type: "sponsorship-spotlight",
      sponsor: "Dimedium",
      class: "gold",
    },    
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "15:00 - 16:00",
      speaker: "Kelly Eyre",
      heading: "Novecojošo kaķu aprūpes klīnikas, integrējot veterināro māsu konsultācijas kaķiem senioriem",
      altheading: "The team approach to feline ageing care",
      language: "EN",
      topic: "Novecojoši kaķi",
      description: "Recognise early behavioural indicators of ageing-related disease in cats, with a focus on changes that are commonly missed in routine practice.\nUnderstand why chronic pain and multimorbidity are under-diagnosed in ageing cats, and how this impacts welfare and quality of life.\nExplore the role of the whole veterinary team—including veterinarians, nurses/technicians, support staff, and owners—in identifying and managing ageing-related changes.\nLearn practical, team-based strategies that can be implemented in everyday practice to improve the care of senior cats without increasing consultation time.",
    },
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "16:00 - 17:00",
      speaker: "Aina Pahomova",
      heading: "Kaķu kategorijas un darbs ar tām veterinārajā klīnikā. Praktiski ieteikumi veterinārmedicīnas personālam.",
      language: "EN",
      topic: "Kaķu labturība",
      description: "",
    },
    {
      //img: require("../assets/img/pattern_react.png"),
      time: "17:00 - 17:15",
      heading: "Noslēguma daļa: auditorijas jautājumi un pateicības",
      description: "",
    }
  ]

  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return width;
  }
  const width = useWindowWidth();


  // Adjust number of columns based on screen width
  let numColumns = 1;
  if (width >= 1024) numColumns = 1; // large screens
  else if (width >= 768) numColumns = 1; // medium screens

  // Split items into columns (round-robin)
  const columnsDay1 = Array.from({ length: numColumns }, () => []);
  const columnsDay2 = Array.from({ length: numColumns }, () => []);

  programmeDay1.forEach((item, index) => {
    columnsDay1[index % numColumns].push(item);
  });
  programmeDay2.forEach((item, index) => {
    columnsDay2[index % numColumns].push(item);
  });
  return (

    <section className="relative block pt-0 mx-auto px-4 py-24 bg-lsfm-primary-800">
      <div className="container mx-auto px-4 ">
        <div className="w-full md:w-9/12 px-4 mr-auto ml-auto">
          <div className="text-warmGray-700 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
            <i className="fas fa-clipboard-list text-xl"></i>
          </div>
          <h3 className="text-3xl mb-2 font-semibold leading-normal text-warmGray-200">
            LSFM Konferences programma
          </h3>
          <h3 className="text-3xl mb-2 font-semibold leading-normal text-warmGray-200">

            "Kaķis nav suns!"
          </h3>
          <p className="text-2xl font-light leading-relaxed mt-4 mb-4 text-warmGray-200">
          </p>

        </div>




        {programmeDay1?.length > 0 && <div>
          <h3 className="text-2xl px-4 mb-2 font-semibold leading-normal text-warmGray-200 pt-12">
          1. diena <br /> 2025. gada 5. decembris (piektdiena)
        </h3>
        <div className="flex gap-4"
          style={{ gridTemplateColumns: `repeat(${numColumns}, minmax(0, 1fr))` }}>
          {columnsDay1.map((colItems, colIndex) => (
            <div key={colIndex} className="flex flex-col items-center gap-6 flex-1">
              {colItems.map((item, index) => {
                if (item.type === "sponsorship-spotlight") {
                  const sponsor = sponsors[`${item.class}`].filter((sponsor) => sponsor.name === item.sponsor)[0];
                  

                  return (
<div key={index + item.type + item.sponsor} className="relative flex flex-col w-full lg:w-8/12 min-w-0 break-words bg-white shadow-lg rounded-lg bg-lsfm-primary-500  my-2">

                    <div className="flex flex-col w-full  p-8">
                      {/* Header */}
                      <div className="flex  items-center">
                        <i className="fas fa-shopping-bag text-3xl text-white mr-3"></i>
                        <p className="text-lg font-medium text-white">Materiāli no {item.sponsor}</p>
                      </div>

                      {/* Files in a horizontal scrollable row */}
                      <div className="flex flex-wrap gap-4 overflow-x-auto justify-center py-2">
                        {sponsor.videoURL && (
                          <div className="px-4 py-2 bg-white rounded-lg shadow flex items-center justify-center" style={{maxWidth: "480px", maxHeight: '360px'}}>
                            <iframe
                              width="100%"
                              height={"100%"}
                              src={sponsor.videoURL}
                              title="Sponsor Video"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              className="rounded-lg"
                            ></iframe>
                          </div>
                        )
                        }
                        {sponsor.files.map((file, fileIndex) => (
                          <a
                            key={fileIndex}
                            href={file.file}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex flex-col items-center justify-between
                     min-w-[150px] h-28 px-4 py-2 border-2 bg-white  shadow
                     hover:shadow-md transition-all rounded-lg"
                          >
                            <i className="fas fa-file-download text-4xl  text-lsfm-primary-600 mb-2"></i>
                            <span className="text-sm max-w-150-px  text-black opacity-80 group-hover:opacity-100 text-center">
                              {file.name}
                            </span>

                            Lejupielādēt
                          </a>
                        ))}
                      </div>
                    </div>
                    </div>

                  )




                }


                return (
                  <div key={index} className="relative flex flex-col w-full lg:w-8/12 min-w-0 break-words bg-white shadow-lg rounded-lg bg-lsfm-primary-500  my-2">
                    {/* Image */}
                    {
                      item.img &&
                      <img
                        alt={item.heading}
                        src={item.img}
                        className="w-full h-32 object-cover rounded-t-lg"
                      />
                    }

                    <blockquote className="relative flex flex-col flex-grow p-8 h-full">

                      <div className="flex justify-between flex-col md:flex-row mb-2">

                        <p className="text-sm font-bold text-white mb-2">
                          {item.time}
                        </p>
                        {item.topic && <span className="text-xs inline-flex items-center text-center justify-center px-3 py-1 font-bold text-white bg-lsfm-primary-700 rounded-full mb-2">                          {item.topic}
                        </span>}
                      </div>

                      {/* Heading */}
                      <h4 className="text-2xl md:text-3xl font-bold text-white mb-2">
                        {item.heading} {item.altheading && <span className="font-normal">({item.altheading})</span>}
                      </h4>

                      {item.speaker && <h5 className="text w-full  text-white mb-2">
                        {item.speaker} {item.language && `(${item.language})`}
                      </h5>}

                      {item.description && <div className={`w-full h-px border-t bg-white my-4`}> </div>}


                      {/* Expandable description */}
                      <ExpandableText text={item.description} />
                    </blockquote>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
        <section className="py-10 bg-lsfm-primary-800 ">
          <div className="flex flex-wrap justify-center">
            <button
              onClick={() => {
                const el = document.getElementById("purchase-section");
                if (el) {
                  const yOffset = -80; // adjust this value to control top spacing
                  const y =
                    el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                  window.scrollTo({ top: y, behavior: "smooth" });
                }
              }}
              className="bg-lsfm-primary-100 text-lsfm-primary-800 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"
            >
              Iegādāties biļeti
            </button>
          </div>
        </section>
        </div>
        }
        <h3 className="text-2xl px-4 mb-2 font-semibold leading-normal text-warmGray-200 mt-20">
          2. diena <br />2026. gada 6. februāris (piektdiena)
        </h3>
        <div className="flex gap-4">
          {columnsDay2.map((colItems, colIndex) => (
            <div key={colIndex} className="flex flex-col items-center gap-6 flex-1">
              
              {colItems.map((item, index) => {
                if (item.type === "sponsorship-spotlight") {
                  const sponsor = sponsors[`${item.class}`].filter((sponsor) => sponsor.name === item.sponsor)[0];
                  

                  return (
<div key={index + item.type + item.sponsor} className="relative flex flex-col w-full lg:w-8/12 min-w-0 break-words bg-white shadow-lg rounded-lg bg-lsfm-primary-500  my-2">

                    <div className="flex flex-col w-full  p-8">
                      {/* Header */}
                      <div className="flex  items-center">
                        <i className="fas fa-shopping-bag text-3xl text-white mr-3"></i>
                        <p className="text-lg font-medium text-white">Materiāli no {item.sponsor}</p>
                      </div>

                      {/* Files in a horizontal scrollable row */}
                      <div className="flex flex-wrap gap-4 overflow-x-auto justify-center py-2">
                        {sponsor.videoURL && (
                          <div className="px-4 py-2 bg-white rounded-lg shadow flex items-center justify-center" style={{maxWidth: "480px", maxHeight: '360px'}}>
                            <iframe
                              width="100%"
                              height={"100%"}
                              src={sponsor.videoURL}
                              title="Sponsor Video"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              className="rounded-lg"
                            ></iframe>
                          </div>
                        )
                        }
                        {sponsor.files.map((file, fileIndex) => (
                          <a
                            key={fileIndex}
                            href={file.file}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex flex-col items-center justify-between
                     min-w-[150px] h-28 px-4 py-2 border-2 bg-white  shadow
                     hover:shadow-md transition-all rounded-lg"
                          >
                            <i className="fas fa-file-download text-4xl  text-lsfm-primary-600 mb-2"></i>
                            <span className="text-sm max-w-150-px  text-black opacity-80 group-hover:opacity-100 text-center">
                              {file.name}
                            </span>

                            Lejupielādēt
                          </a>
                        ))}
                      </div>
                    </div>
                    </div>

                  )




                }


                return (
                  <div key={index} className="relative flex flex-col w-full lg:w-8/12 min-w-0 break-words bg-white shadow-lg rounded-lg bg-lsfm-primary-500  my-2">
                    {/* Image */}
                    {
                      item.img &&
                      <img
                        alt={item.heading}
                        src={item.img}
                        className="w-full h-32 object-cover rounded-t-lg"
                      />
                    }

                    <blockquote className="relative flex flex-col flex-grow p-8 h-full">

                      <div className="flex justify-between flex-col md:flex-row mb-2">

                        <p className="text-sm font-bold text-white mb-2">
                          {item.time}
                        </p>
                        {item.topic && <span className="text-xs inline-flex items-center text-center justify-center px-3 py-1 font-bold text-white bg-lsfm-primary-700 rounded-full mb-2">                          {item.topic}
                        </span>}
                      </div>

                      {/* Heading */}
                      <h4 className="text-2xl md:text-3xl font-bold text-white mb-2">
                        {item.heading} {item.altheading && <span className="font-normal">({item.altheading})</span>}
                      </h4>

                      {item.speaker && <h5 className="text w-full  text-white mb-2">
                        {item.speaker} {item.language && `(${item.language})`}
                      </h5>}

                      {item.description && <div className={`w-full h-px border-t bg-white my-4`}> </div>}


                      {/* Expandable description */}
                      <ExpandableText text={item.description} />
                    </blockquote>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
        <section className="py-10 bg-lsfm-primary-800 ">
          <div className="flex flex-wrap justify-center">
            <button
              onClick={() => {
                const el = document.getElementById("purchase-section");
                if (el) {
                  const yOffset = -80; // adjust this value to control top spacing
                  const y =
                    el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                  window.scrollTo({ top: y, behavior: "smooth" });
                }
              }}
              className="bg-lsfm-primary-100 text-lsfm-primary-800 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"
            >
              Iegādāties biļeti
            </button>
          </div>
        </section>
      </div>




    </section>
  );
};



export default ProgrammeSection;